/**
 * Convert English digits to Bengali digits
 * @param {number|string} number - The number to convert
 * @returns {string} - Bengali formatted number
 */
export const toBengaliNumber = (number) => {
  if (number === null || number === undefined) return '';
  
  const englishDigits = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  const bengaliDigits = ['০', '১', '২', '৩', '৪', '৫', '৬', '৭', '৮', '৯'];
  
  const numStr = number.toString();
  let result = '';
  
  for (let i = 0; i < numStr.length; i++) {
    const char = numStr[i];
    const index = englishDigits.indexOf(char);
    result += index !== -1 ? bengaliDigits[index] : char;
  }
  
  return result;
};
